<div class="vh-100 overflow-auto">
  <div class="offcanvas-header gap-2 pb-0 align-items-center">
    <div class="col">
      @if (header) {
        <div [innerHTML]="header"></div>
      }
      <h3 id="offcanvasRightLabel" data-testid="addFilterTitle"><span>Add filter</span></h3>
    </div>
    <button
      (click)="activeOffcanvas.dismiss()"
      type="button"
      class="btn-close text-reset"
      data-cy="closeBtn"
      data-testid="closeBtn"
      aria-label="Close"
    ></button>
  </div>
  @if (isLoadingFilterDefinitions()) {
    <app-loading-spinner [isLoading]="true" />
  } @else {
    <div class="offcanvas-body pt-3">
      @if (filtersCount() > 10) {
        <div class="card mb-3">
          <chitin-form-input
            #filterSearch
            placeholder="Search filters..."
            [(value)]="searchQuery"
            size="small"
            data-testid="addFilterSearch"
          />
        </div>
      }
      @if (filtersCount() === 0) {
        <div class="alert alert-warning">No filters available</div>
      } @else if (filteredFiltersCount() === 0) {
        <div class="alert alert-warning">No filters found matching search criteria</div>
      }
      @if (uncategorizedFiltersFilteredBySearch().length > 0) {
        <div class="card overflow-hidden" data-testid="filterGroup">
          <div class="list-group d-flex flex-row flex-wrap">
            @for (filter of uncategorizedFiltersFilteredBySearch(); track filter.id) {
              <a
                (click)="onFilterSelected(filter)"
                class="p-3 list-group-item-action listGroupFilter d-flex justify-content-between"
                data-cy="filterSelect"
                data-testid="filterSelect"
                placement="top-left"
                container="body"
                [class.noClick]="!!filter.required"
              >
                <div data-testid="filterSelectValue">{{ filter.display }}</div>
                @if (filter.disabled) {
                  @if (!!filter.required) {
                    <div class="text-info ms-4 text-nowrap">
                      <span class="ms-2">Required</span>
                    </div>
                  } @else {
                    <div class="text-success ms-4 text-nowrap">
                      <chitin-icon icon="fa-solid fa-check" />
                      <span class="ms-2">Added</span>
                    </div>
                  }
                }
              </a>
            }
          </div>
        </div>
      }
      @for (fcat of filterCategories; track fcat) {
        <div class="mb-3">
          @if (filtersFilteredBySearch().hasOwnProperty(fcat.id) && filtersFilteredBySearch()[fcat.id].length > 0) {
            <h5 class="mb-3">{{ fcat.name }}</h5>
            @if (fcat.description) {
              <p>{{ fcat.description }}</p>
            }
            <div class="card overflow-hidden" data-testid="filterGroup" [attr.data-group-name]="fcat.name">
              <div class="list-group d-flex flex-row flex-wrap">
                @for (f of filtersFilteredBySearch()[fcat.id]; track f.id) {
                  <a
                    (click)="onFilterSelected(f)"
                    class="p-3 list-group-item-action listGroupFilter d-flex justify-content-between"
                    data-cy="filterSelect"
                    data-testid="filterSelect"
                    placement="top-left"
                    container="body"
                    [class.noClick]="!!f.required"
                  >
                    <div data-testid="filterSelectValue">{{ f.display }}</div>
                    @if (f.disabled) {
                      @if (!!f.required) {
                        <div class="text-info ms-4 text-nowrap">
                          <span class="ms-2">Required</span>
                        </div>
                      } @else {
                        <div class="text-success ms-4 text-nowrap">
                          <chitin-icon icon="fa-solid fa-check" />
                          <span class="ms-2">Added</span>
                        </div>
                      }
                    }
                  </a>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
